import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { colors } from '../../assets/utils/constants';
import { useState } from 'react';
import OrganizationFieldWidget from '../widgets/OrganizationFieldWidget';

// ######################## Table column #######################
const columns = [{ id: 's_n', label: 'S/N', minWidth: 1 }];
function createData(s_n) {
    return {
        s_n,
    };
}

// !###################### MAIN FUNC ########################
const OrgWithFieldVacancyTable = () => {
    // -> Table state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(2);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // ######################## TABLE ROW #######################
    const rows = [1, 2, 3, 4, 5]?.map((index) => {
        return createData(<OrganizationFieldWidget />);
    });

    return (
        <React.Fragment>
            <Paper
                sx={{
                    width: '100%',
                    overflow: 'hidden',
                    background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    boxShadow: 'none',
                }}
            >
                <TableContainer sx={{ height: 200 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableBody>
                            {rows
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage,
                                )
                                .map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={index}
                                        >
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        sx={{ p: 0 }}
                                                    >
                                                        {column.format &&
                                                        typeof value ===
                                                            'number'
                                                            ? column.format(
                                                                  value,
                                                              )
                                                            : value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* <TablePagination
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                        '& .MuiTablePagination-selectLabel, .MuiInputBase-root': {
                            display: 'none !important',
                        },
                        'background': `linear-gradient(180deg, ${colors.bgColor3}, ${colors.bgColor4})`,
                    }}
                /> */}
            </Paper>
        </React.Fragment>
    );
};

export default OrgWithFieldVacancyTable;
